import { InitialOnboardingSteps, ProgresStepType, Tooltip } from '../constants/content';
import { OnboardingVersionType } from '../states/OnboardingProvider';
import { CoreStepsSeenFieldsFragment } from '../../../models/graphql';

export const getOnboardingSteps = (version: OnboardingVersionType, stepsSeen: CoreStepsSeenFieldsFragment[]) => {
  const onboardingStepsSeenForVersionKeys = stepsSeen
    .filter(step => step.name.startsWith(`v${version}`))
    .map(step => step.name);
  return InitialOnboardingSteps[`v${version}`].map(step => {
    const tooltips = step.tooltips.map(tooltip =>
      onboardingStepsSeenForVersionKeys.includes(tooltip.id) ? { ...tooltip, completed: true } : tooltip
    );
    if (onboardingStepsSeenForVersionKeys.includes(step.key)) {
      return {
        ...step,
        completed: true,
        tooltips
      };
    }
    return { ...step, tooltips };
  });
};

export const getStringifiedStepRoutes = (version: OnboardingVersionType) => {
  return InitialOnboardingSteps[`v${version}`].flatMap(step => step.route).join(',');
};

export const getToolTip = (key: string, progress: ProgresStepType[]): Tooltip | null => {
  const tooltips = progress.flatMap(step => step.tooltips);
  return tooltips.find(t => t.id === key) || null;
};
